import React, { useEffect } from 'react';
import { toast } from '@/components/ui/sonner';
import { motion } from 'framer-motion';
import { stagger, fadeUp } from '@/lib/motion';
import { useCoverClub } from './context/CoverClubContext';
import CoverBattleCard from './CoverBattleCard';

export default function BattlesSection() {
  const { battles, loadBattles } = useCoverClub();

  useEffect(() => {
    loadBattles().catch((error) => toast(error.message || 'We could not load cover battles.'));
  }, [loadBattles]);

  return (
    <motion.div variants={stagger} initial="hidden" animate="show" className="grid gap-4 sm:grid-cols-2" data-testid="cover-club-battles">
      {battles.map((battle, i) => (
        <motion.div key={battle.id} variants={fadeUp} custom={i}>
          <CoverBattleCard battle={battle} />
        </motion.div>
      ))}
    </motion.div>
  );
}
